import * as React from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import styled from "styled-components"

import Menu from "./menu"
import Logo from "./logo"

const StyledHeader = styled.header`
  background: #fff;
  margin-bottom: 0;
  position: sticky;
  top: -1px;
  width: 100%;
  z-index: 5;
  box-shadow: 0 -6px 10px 5px rgba(0,0,0,0.5);

  &[data-trapped="true"] {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;

    & ~ * {
      height: 100vh;
      overflow: hidden;
    }
  }

  @media (max-width: 756px) {
    position: absolute;
    min-height: 66px;
  }
`

const MobileCTA = styled(Link)`
  position: fixed;
  bottom: 0;
  border-radius: 0;
  width: 100%;
  background: #000;
  color: #FFF;
  padding: 10px;
  text-decoration: none;
  font-weight: 700;
  font-size: 1.3rem;
  text-align: center;
  display: none;

  @media (max-width: 756px) {
    display: block;
  }
`

const FlexBox = styled.div`
  margin: 0 auto;
  max-width: 1366px;
  padding: 0 1.0875rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  max-height: 66px;

  @media (max-width: 1203px) {
    min-height: 56px;
  }

  @media (max-width: 756px) {
    max-height: none;
    min-height: 100%;
  }

  @media (max-width: 500px) {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    justify-content: space-between;
    gap: 1rem;
  }

  @media (max-width: 315px) {
    justify-content: center;
    gap: 0.5rem;
  }
`

const HomeH1 = styled.h1`
  margin: 0;
  padding: 0;
  line-height: 1;
  font-size: 24px;

  @media (max-width: 756px) {
    flex: 1;
  }
`

const HomeLink = styled(Link)`
  color: #222a3f;
  text-decoration: none;
  font-size: 24px;
  font-weight: 700;
  text-transform: uppercase;
  position: relative;
  padding-left: 0;
  display: block;

  @media (max-width: 756px) {
    max-width: 100%;

    svg {
      max-width: 100%;
      height: auto;
    }
  }
`

const StickyHeader = ({
  stuckClassName = "",
  className = "",
  children
}) => {
  const [stuck, setStuck] = React.useState(false)
  const ref = React.createRef()

  const classes = stuck ? `${className} ${stuckClassName}` : className

  React.useEffect(() => {
    const cachedRef = ref.current
    const observer = new IntersectionObserver(
      ([e]) => {setStuck(e.intersectionRatio < 1);},
      { threshold: [1] }
    )
    observer.observe(cachedRef)
    return () => observer.unobserve(cachedRef)
  }, [ref])

  return (
    <StyledHeader className={classes} ref={ref}>
      {children}
    </StyledHeader>
  )
}

const Header = (slug = '') => (
  <StickyHeader className="page-header" stuckClassName="sticky" id="page-header">
    <FlexBox>
      <HomeH1>
        <HomeLink to="/">
          <Logo />
        </HomeLink>
      </HomeH1>
      <Menu />
    </FlexBox>
    { 'request-appointment' !== slug &&
      <MobileCTA to="/request-appointment">
        <span>➥ </span>
        Request Consultation
      </MobileCTA>
    }
  </StickyHeader>
)

Header.propTypes = {
  slug: PropTypes.string,
}

export default Header
